import { Component, Input } from '@angular/core';
import { ProfilePictureApprovalSharedData, ProfilePictureApprovalService } from './profile-picture-approval.service';

@Component({
  selector: 'cv-profile-picture-approval',
  templateUrl: './profile-picture-approval.component.html',
  styleUrls: ['./profile-picture-approval.component.scss']
})
export class ProfilePictureApprovalComponent {

  public ppas: ProfilePictureApprovalSharedData;
  public imgLink: string;
  public statusKnown = false;
  public processingAnswer = false;
  @Input() resolve: ProfilePictureApprovalSharedData = null as any;
  @Input() modalInstance: any;

  constructor(
    private profilePictureApprovalService: ProfilePictureApprovalService
  ) {
    this.ppas = this.profilePictureApprovalService.dataObj;
    this.imgLink = `../Admin/ImageResizer.aspx?imgid=${this.ppas.imageId}&w=140&h=140`;

    this.constructorAsync();
  }

  /**
   * Gets localization fields and sets data values.
   * */
  public async constructorAsync() {
    this.ppas.loginId = this.resolve.loginId;
    this.ppas.imageId = this.resolve.imageId;
    this.ppas.loginName = this.resolve.loginName;

    try {
      let userProfileDto: any = await this.profilePictureApprovalService.getUserProfile();
      this.ppas.isApproved = userProfileDto.isApproved;
    }
    finally {
      this.statusKnown = true;
    }
  }

  public async approve() {
    this.processingAnswer = true;
    await this.profilePictureApprovalService.approveProfilePicture();
    this.processingAnswer = false;
    this.closePopup();
  }

  public async deny() {
    this.processingAnswer = true;
    await this.profilePictureApprovalService.denyProfilePicture();
    this.processingAnswer = false;
    this.closePopup();
  }

  public closePopup() {
    this.modalInstance.dismiss();
  }

}
